import type { modalKeys } from '../../../constants/modalKeys'
import type { AppDispatch } from '../../configureStore'
import { showModal as showModalAction } from '../../slices/modal.slice'

export type ModalShowAction = {
  type: 'MODAL_SHOW'
  payload:
    | {
        modalShown: typeof modalKeys.connectWallet
        modalPayload: undefined
      }
    | {
        modalShown: typeof modalKeys.connectedWalletsMobile
        modalPayload: undefined
      }
}

export const showModal =
  (dispatch: AppDispatch) =>
  <T extends ModalShowAction['payload']['modalShown']>(
    modalShown: T,
    modalPayload?: Extract<ModalShowAction['payload'], { modalShown: T }>['modalPayload'],
  ) => {
    // Can't figure out a way to make this better:
    // showModal() accepts only matching shown and payload, f.e.:
    // valid:
    // showModal(dispatch)(xchainSuccessModalKey, { tokenFrom: 'test', tokenTo: 'test' })
    // invalid:
    // showModal(dispatch)(xchainSuccessModalKey, { bar: 'test', foo: 'test' })
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- explaination above
    dispatch(showModalAction({ modalShown, modalPayload } as ModalShowAction['payload']))
  }
